import { render, staticRenderFns } from "./TeacherEduEdit.vue?vue&type=template&id=733a4ba0&scoped=true&"
import script from "./TeacherEduEdit.vue?vue&type=script&lang=js&"
export * from "./TeacherEduEdit.vue?vue&type=script&lang=js&"
import style0 from "./TeacherEduEdit.vue?vue&type=style&index=0&id=733a4ba0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733a4ba0",
  null
  
)

export default component.exports